import { cn } from '@/context/global/utils/cn';

export type TSearchIconProps = {
  className?: string;
  size?: number;
};

export default function IconArrowThin({ className = '', size = 24 }: TSearchIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('text-white', className)}
    >
      <path
        d="M18.6667 9.3335L12 16.0002L18.6667 22.6668"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
